import { useToastContext } from "./useToastContext.js";

export const useToast = () => {
  const { showToast } = useToastContext();
  return showToast;
};
